import { render, staticRenderFns } from "./DashBoardView.vue?vue&type=template&id=c6f5ae7c&scoped=true"
import script from "./DashBoardView.vue?vue&type=script&lang=js"
export * from "./DashBoardView.vue?vue&type=script&lang=js"
import style0 from "@/other/assets/css/tour.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/other/assets/css/app.css?vue&type=style&index=1&id=c6f5ae7c&prod&scoped=true&lang=css&external"
import style2 from "@/other/assets/css/loading.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "./DashBoardView.vue?vue&type=style&index=3&id=c6f5ae7c&prod&scoped=true&lang=css"
import style4 from "./DashBoardView.vue?vue&type=style&index=4&id=c6f5ae7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f5ae7c",
  null
  
)

export default component.exports